export default __webpack_public_path__ + "static/media/Saibaba5.4aae1f02.jpg";